import type { DummyFoods } from './dummyFoods'

export const bread: DummyFoods = {
  Bread: {
    French: ['French bread'],
    Italian: ['Italian bread'],
    'Multi-grain': ['Multi-grain bread'],
    Naan: ['Naan bread'],
    Pita: ['Pita bread'],
    Rye: ['Rye bread'],
    Sourdough: ['Sourdough bread'],
    White: ['White bread'],
    'Whole wheat': ['Whole wheat bread'],
  },
}
